// extracted by mini-css-extract-plugin
export var carrierIcon = "_y0-0";
export var carrierLogo = "_y0-1";
export var detailsSection = "_y0-2";